<template>
  <div>
    <b-row>
      <b-col cols="5" class="mr-0">
        <vue-single-select
          :classes="{
            input: 'form-control',
            dropdown: 'dropdown p-0',
          }"
          v-model="selected"
          :options="users"
          optionLabel="nickname"
        >
          <template slot="option" class="p-0" slot-scope="{ option }">
            <div class="">
              <!--             <span> {{ option.firstName }} {{ option.lastName }}</span>
 -->
              <span> {{ option.nickname }}</span>
            </div>
          </template>
        </vue-single-select>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { GET_MARKETPLACE_USERS } from "./actions";
import VueSingleSelect from "vue-single-select";

import { mapState } from "vuex";
export default {
  components: { VueSingleSelect },
  computed: {
    ...mapState({
      users: (state) => state.masterUser.marketplace.users.data,
    }),
  },
  watch: {
    selected(val) {
      if (val) {
        this.selected = val;
        this.$emit("user-select", val);
      }
    },
  },
  data() {
    return {
      selected: null,
    };
  },
  created() {
    this.getUsersPermission();
  },
  methods: {
    getUsersPermission() {
      this.$store
        .dispatch(GET_MARKETPLACE_USERS, {})
        .then(() => {})
        .catch(() => {});
    },
    clearUserSelect() {
      this.selected = null;
    },
    /*   onUserSelect(user) {
      this.$emit("user-select", user);
    }, */
  },
};
</script>
